import Axios from 'axios'
import moment from "moment";

const getRelativeDate = (relativeDate) => {
    return Axios.get(`frontend/api/v1/utils/date/date-expressions?dateExpression=${encodeURIComponent(relativeDate)}`)
        .then(res => res.data);
}

/**
 *
 * @param propertyName Property name on object.
 * @param startDate
 * @param endDate
 * @param inclusivity
 * @param granularity
 * @returns {function(*): boolean} Function which takes object with propertyName property and decide if property is in interval.
 */
const isInInterval = (propertyName, startDate, endDate, inclusivity = '[]', granularity = 'days') =>
    /**
     * Function which takes object with propertyName property and decide if property is in interval.
     * @param entity {Object}
     * @returns {boolean}
     */
     entity => {
        const momentDate = moment(entity[propertyName]);

        const momentFrom = moment(startDate);
        const momentThru = moment(endDate);

        return momentDate.isBetween(momentFrom, momentThru, granularity, inclusivity)
    }

export { getRelativeDate, isInInterval };